import {Component, OnInit} from '@angular/core';
import {RecentProjectsService} from "./recent-projects.service";
import { AuthService } from '@app/core/services';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sa-recent-projects',
  templateUrl: './recent-projects.component.html',
  providers: [RecentProjectsService]
})
export class RecentProjectsComponent implements OnInit {

  projects: Array<any>;
  offices: any;
  user:any;


  constructor(private projectsService: RecentProjectsService, private auth: AuthService) {

  }

  async ngOnInit() {

    this.user = await this.auth.getCurrentUser();
    this.offices = await this.auth.getOfficesAuth(this.user).snapshotChanges().pipe(
      map(arr => arr.map(doc => {
        if(this.auth.getOfficeSelected() == null)
          this.auth.setOfficeSelected(doc.payload.doc.data());
        return { id: doc.payload.doc.id, ...doc.payload.doc.data()};
      }))
    );
    
  }

  selectOffice(office:any){    
    this.auth.setOfficeSelected(office);
    window.location.reload();
  }

  get officeSelected(){
    return this.auth.getOfficeSelected();
  }

  trackByFn(index, office){
    return office.uid;
  }

}
